import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { MdArrowUpward } from "react-icons/md";

import { useClipCommentForm } from "MVVM/Hooks/useClipCommentForm";

interface IClipCommentFormProps {
  clipId: string;
}

export const ClipCommentForm = ({ clipId }: IClipCommentFormProps) => {
  const {
    loading,
    inputRef,
    disabled,
    handleFocus,
    handleKeyDown,
    handleInput,
    handlePaste,
    handleClick,
  } = useClipCommentForm({ clipId });

  return (
    <Flex>
      <InputWrapper loading={loading} onFocus={handleFocus} id="die">
        <Input
          ref={inputRef}
          role="textbox"
          contentEditable={!loading}
          onKeyDown={handleKeyDown}
          aria-multiline="false"
          onInput={handleInput}
          onPaste={handlePaste}
          data-placeholder="Add a comment..."
        />
        <ButtonContainer>
          <StyledButton
            onClick={disabled ? undefined : handleClick}
            disabled={disabled}
          >
            <StyledMdArrowUpward />
          </StyledButton>
        </ButtonContainer>
      </InputWrapper>
    </Flex>
  );
};

const InputWrapper = styled(Flex)<{ loading: boolean }>`
  align-items: flex-end;
  background: ${({ theme }) => theme.colors.midnightBlue};
  border: 1px solid ${({ theme }) => theme.colors.navy50};
  border-radius: 8px;
  color: ${({ loading, theme }) =>
    loading ? theme.colors.chalk : theme.colors.ice};
  cursor: ${({ loading }) => (loading ? "not-allowed" : "text")};
  max-width: 100%;
  min-height: 36px;
  padding: 0px 8px;
  width: 100%;
`;

const Input = styled(Box)`
  align-self: center;
  display: block;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  outline: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-height: 5.6em;
  overflow-y: auto;

  :empty::before {
    color: ${({ theme }) => theme.colors.chalkAlpha80};
    content: attr(data-placeholder);
  }

  :empty:focus::before {
    content: "";
  }

  br {
    display: none;
  }
`;

const ButtonContainer = styled(Flex)`
  align-items: center;
  align-self: center;
  flex-shrink: 0;
  flex-grow: 0;
  gap: 8px;
  margin-left: 8px;
`;

const StyledButton = styled(Flex)<{ disabled: boolean }>`
  align-items: center;
  align-self: center;
  background: ${(props) =>
    props.disabled ? props.theme.colors.ned : props.theme.colors.envy};
  border-radius: 99px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  flex-grow: 0;
  flex-shrink: 0;
  height: 28px;
  justify-content: center;
  line-height: 0;
  padding: 0;
  width: 28px;

  :hover {
    background: ${(props) =>
      props.disabled ? props.theme.colors.ned : props.theme.colors.envyAlpha80};
  }
`;

const StyledMdArrowUpward = styled(MdArrowUpward)`
  height: 16px;
  width: 16px;
  color: ${({ theme }) => theme.colors.ice};
`;
